const config = {
  SCAN_ACCOUNT_URL: 'https://ethereum-api.xyz',
  BRIDGE_URL: process.env.VUE_APP_BASE_BRIDE_URL,
  API_URL: process.env.VUE_APP_BASE_API_URL,
  INFURA_URL: 'https://mainnet.infura.io/v3/bf140f77ebb648e4995f804b1659611d',
  ROOT_ADDRESS: '0x2fa614189c511e3498b3723a6b84debbcdd80e98',
  IS_DEVELOPMENT: process.env.NODE_ENV === 'dev'
}

export default config
